<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("User Cashier summary Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("cinema", 1)
                }}</label>
              <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
                :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
                @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>

            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'" :not-after="disabledAfter" :disabledDates="{ from: new Date(Date.now()) }">
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("fromDate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="toDate"
                  v-validate="'required'" :not-after="disabledAfter" @selected="getUserList()"
                  :disabledDates="{ from: new Date(Date.now()) }"></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("toDate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <label  :class="selectedUsers.length == 0 ? 'shift-up' : ''">
                    {{ $t("select") }} {{ $tc("Users", 1) }}
                    </label> -->
              <multiselect :disabled="isRoleID" :options="userList" v-model="selectedUsers" :searchable="true"
                label="username" track-by="user_id" placeholder="Select Users" :showLabels="false" :multiple="true">
              </multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="getUserCashierSummary({ type: '', isPdf: 'N' })">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="transectionList.length > 0">
            <div class="mx-1">{{ $t("download") }} as:</div>

            <span @click="getUserCashierSummary({ type: '', isPdf: 'Y' })" title="Download as Pdf">
              <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>
      <div>
        <div class="table-scroll">
          <table class="swc-report-table swc_table_header" border="1" id="myTable" v-if="transectionList.length > 0">
            <thead class="bg-lightgrey font-weight-bold">
              <th>{{ $t("User Name ") }} </th>
              <th>{{ $t("Outlet") }} </th>
              <th>{{ $t("Payment Type") }} </th>
              <th>{{ $t("Tickets") }} </th>
              <th>{{ $t("Revenue") }} </th>
              <th>{{ $t("Discount") }} </th>
              <th>{{ $t("Balance") }} </th>


            </thead>
            <tbody>

              <template v-for="(record, index) in transectionList">

                <tr v-for="(transaction, PIndex) in record.paymentWise" :key="PIndex + '_' + index">
                  <!-- <td v-if="tIndex==0"  :rowspan="record.transactionsData.length+1">{{ record.date }}</td> -->
                  <td v-if="PIndex == 0" class="text-left border-1 border-bottom-0 ">{{ record.username }}</td>
                  <td v-else class=" border-1 border-bottom-0 border-top-0"></td>
                  <td></td>
                  <td class="text-left">{{ transaction.payment_type }}</td>
                  <td class="text-right">{{ transaction.tickets }}</td>
                  <td class="text-right">{{ currFormat(transaction.revenue) }}</td>
                  <td class="text-right">{{ currFormat(transaction.discount) }}</td>
                  <td class="text-right">{{ currFormat(transaction.balance) }}</td>

                </tr>
                <tr v-for="(transaction, BIndex) in record.bookingWise" :key="BIndex + '_' + index">
                  <td class=" border-1 border-bottom-0 border-top-0"></td>

                  <td class="text-left">{{ transaction.booking_source }}</td>
                  <td></td>
                  <td class="text-right">{{ transaction.tickets }}</td>
                  <td class="text-right">{{ currFormat(transaction.revenue) }}</td>
                  <td class="text-right">{{ currFormat(transaction.discount) }}</td>
                  <td class="text-right">{{ currFormat(transaction.balance) }}</td>
                </tr>
                <tr class="bg-lightgrey font-weight-bold" :key="`total_` + index">
                  <td class="text-left">
                    {{ record.username }}
                  </td>
                  <td></td>
                  <td></td>
                  <td class="text-right">{{ record.totalTicket }}</td>
                  <td class="text-right">{{ currFormat(record.totalRevenue) }}</td>
                  <td class="text-right">{{ currFormat(record.totalDiscount) }}</td>
                  <td class="text-right">{{ currFormat(record.totalBalance) }}</td>

                </tr>
              </template>


            </tbody>

          </table>
          <table v-else class="swc-report-table swc_table_header" border="1" id="myTable">
            <thead class="bg-lightgrey font-weight-bold">
              <th>{{ $t("User Name ") }} </th>
              <th>{{ $t("Outlet") }} </th>
              <th>{{ $t("Payment Type") }} </th>
              <th>{{ $t("Tickets") }} </th>
              <th>{{ $t("Revenue") }} </th>
              <th>{{ $t("Discount") }} </th>
              <th>{{ $t("Balance") }} </th>


            </thead>
            <tr>
              <td :colspan="7">
                <NoRecords />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import FnBReportService from "@/services/FnBReportsService";
import PosFnbService from "@/services/PosFnbService"
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    NoRecords
  },
  data() {
    return {

      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      userList: [],
      selectedUsers: [],
      transectionList: [],
      fromDate: new Date(),
      toDate: new Date(),
      isRoleID: false,
      disabledAfter: new Date(),
      grandTotal: 0,
    }
  },
  beforeMount() {
    //     Records.forEach(obj => {
    //     let totalAmount = 0;
    //     obj.transactionsData.forEach(transaction => {
    //         totalAmount += transaction.amount;
    //     });
    //     obj.total = totalAmount;
    // });
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }

  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);


      }
    },
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },
  methods: {
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;

          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;

      this.$store.dispatch("selectDropdownCinema", event);
    },
    getUserList: function () {
      this.getUserCashierSummary({ type: "users" })
    },
    check: function () {
      console.log("selecteduser=>", this.selectedUsers)
    },
    getUserCashierSummary: function ({ type, isPdf }) {
      let payload = {
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        cinema_address: this.dropDown.selectedCinema.cine_address,

        type: type || "",
        isPdf: isPdf || "N"
      }
      // if(dataType){
      //   payload={...dataType,...payload}
      // } 
      if (this.selectedUsers.length > 0) {
        payload.user_id = this.selectedUsers.map(user => user.user_id);
      }

      let loader = this.$loading.show();
      ReportsService.GetUserCashierSummary(payload).then(response => {
        const { data } = response;
        if (data.status && data.Records && data.Records.length > 0) {
          console.log("payload=>", payload.type)
          if (type == "users") {
            this.userList = data.Records
          }
          else {
            this.transectionList = data.Records.map(item => {
              let totalTicket = 0;
              let totalRevenue = 0;
              let totalDiscount = 0;
              let totalBalance = 0;
              totalTicket = item.paymentWise.reduce((acc, transaction) => acc + transaction.tickets, 0);
              totalRevenue = item.paymentWise.reduce((acc, transaction) => acc + transaction.revenue, 0);
              totalDiscount = item.paymentWise.reduce((acc, transaction) => acc + transaction.discount, 0);
              totalBalance = item.paymentWise.reduce((acc, transaction) => acc + transaction.balance, 0);
              return { ...item, totalTicket, totalRevenue, totalDiscount, totalBalance, };

            });
            if (data.grandTotal) {
              this.grandTotal = data.grandTotal.amount || 0
            }
          }
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank")
          }
        }
        else {
          this.$toasted.show(data.message);
        }
      })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },

  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/userCashierSummaryReport.vue